import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps} from 'search/filters/base/FilterFormConstants';
import SecondaryFilterFormSkeleton from 'search/filters/base/SecondaryFilterFormSkeleton';
import SearchInput from 'search/inputs/SearchInput';
import {TranscriptionFilter} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

interface TranscriptionsFilterFormProps extends BaseFilterFormProps {
  filter: TranscriptionFilter;
  onChangeFilter: (filter: TranscriptionFilter) => void;
  onRemove: () => void;
}

export default function TranscriptionsFilterForm(props: TranscriptionsFilterFormProps): JSX.Element {
  const input = (
    <SearchInput
      isMulti={true}
      types={[ModelTypeConstants.RNA_SEQUENCE]}
      placeholder="Search by name"
      selected={props.filter.value}
      onSelect={(id) => {
        const newValue = props.filter.value.includes(id!) ? props.filter.value : [...props.filter.value, id!];
        props.onChangeFilter({
          ...props.filter,
          value: newValue,
        });
      }}
      onRemove={(id) => {
        const newValue = props.filter.value.filter((prevId) => prevId !== id);
        props.onChangeFilter({
          ...props.filter,
          value: newValue,
        });
      }}
      disabled={props.locked}
    />
  );

  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);

  return <SecondaryFilterFormSkeleton {...skeletonProps} nodeGrid={[[input]]} onRemove={props.onRemove} />;
}
